/**
 * Проверяет, является ли переданное значение значением одного из полей объекта.
 * Не работает на литералах, обобщайте тип до string или number.
 *
 * @param value Значение, наличие которого проверяется
 * @param obj Объект
 * @typeParam T Тип объекта
 * @returns true, если переданное значение является значением одного из полей объекта, иначе false
 */
export const isObjectValue = (value, obj) => {
    return Object.values(obj).includes(value);
};
